<script setup lang="ts">
</script>

<template>
  <h2 class="mb-6 text-lg font-medium leading-6">
    <slot></slot>
  </h2>
</template>
